import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import BlurPicture from '@blade/common/components/blur-picture/index.vue';
import ResultPage from '@blade-sxp/data-mining/components/result-page.vue';
import { getAllTaskList } from '@blade-sxp/data-mining/apis/index';
let default_1 = class default_1 extends Vue {
    fileIDVisible;
    loading;
    title;
    imgList;
    sliderValue = 0;
    imgUrl = require('@blade-sxp/data-mining/assets/images/1.png');
    privacyMode = localStorage.getItem('privacyMode') || 'false';
    input4 = '';
    cardList = '';
    disabled = true;
    searchDisabled = true;
    isChecked = true;
    isClose = true;
    taskList = [];
    form = {
        taskVal: '',
        input: '',
    };
    isInput(val) {
        if (val?.taskVal && val?.input) {
            this.searchDisabled = false;
        }
        else {
            this.searchDisabled = true;
        }
    }
    isClosed(val) {
        if (val) {
            this.isClose = !this.isClose;
            this.disabled = true;
            this.form = {
                taskVal: '',
                input: '',
            };
        }
    }
    mounted() {
        this.initData();
    }
    initData() {
        const param = {
            taskTypes: ['REALTIME_CLUSTER'],
        };
        getAllTaskList(param).then((res) => {
            this.taskList = res;
        });
    }
    getName(val) {
        if (val) {
            return val;
        }
        return this.$t('name');
    }
    handleClose() {
        this.$emit('close');
        this.isChecked = !this.isChecked;
        this.input4 = '';
    }
    changeList(val) {
        // 弹框内容是否选择
        if (val) {
            this.disabled = false;
            this.cardList = val;
        }
        else {
            this.disabled = true;
        }
    }
    save() {
        this.$emit('data', this.cardList);
    }
    changeId(val, id) {
        this.$emit('change-id', val, id);
    }
};
__decorate([
    Prop({ default: false })
], default_1.prototype, "fileIDVisible", void 0);
__decorate([
    Prop({ default: false })
], default_1.prototype, "loading", void 0);
__decorate([
    Prop()
], default_1.prototype, "title", void 0);
__decorate([
    Prop()
], default_1.prototype, "imgList", void 0);
__decorate([
    Watch('form', { immediate: true, deep: true })
], default_1.prototype, "isInput", null);
__decorate([
    Watch('fileIDVisible')
], default_1.prototype, "isClosed", null);
default_1 = __decorate([
    Component({
        name: 'fileId',
        components: { BlurPicture, ResultPage },
        i18n: {
            messages: {
                en: {
                    similarity: 'Similarity',
                    save: 'Save',
                    cancel: 'Cancel',
                    portraits: 'Portraits',
                    name: 'Anonymous',
                    search: 'Search',
                    placeholderTask: 'Please select file cluster task',
                },
                zh: {
                    similarity: '相似度',
                    save: '保存',
                    cancel: '取消',
                    portraits: '人像库',
                    name: '未知身份',
                    search: '搜索',
                    placeholderTask: '请选择聚档任务',
                },
            },
        },
    })
], default_1);
export default default_1;
